var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueVideoThumbnail',{attrs:{"video-src":_vm.src,"snapshot-at-duration-percent":1,"width":500,"height":300,"chunks-quantity":10},scopedSlots:_vm._u([{key:"snapshot",fn:function({ snapshot }){return [(snapshot)?_c('img',{attrs:{"src":snapshot,"alt":"snapshot"}}):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }